import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import actions from 'redux/actions'
import Media from 'sb-media'
import ValueLink from 'sb-valuelink'
import { mixpanel, array, constants } from 'common/helpers'
import { FormattedMessage } from 'sb-react-intl'

import RadioGroup from 'components/forms/RadioGroup/RadioGroup'
import RadioButton from 'components/forms/RadioButton/RadioButton'
import UpgradeButton from 'components/buttons/UpgradeButton/UpgradeButton'
import Button from 'components/buttons/Button/Button'

import Title from '../Title/Title'

import messages from './messages'
import s from './MonthlyPlanOptions.scss'

import getMore from './images/getMore.svg'


class MonthlyPlanOptions extends Component {

  static propTypes = {
    onClose: PropTypes.func.isRequired,
    goToStep: PropTypes.func.isRequired,
  }

  state = {
    activePlan: 1,
  }

  upgrade = () => {
    const { activePlan } = this.state
    const { goToStep } = this.props

    mixpanel.track(constants.analyticsEvents.upgradePopup, { placement: 'queue popup' })
    actions.models.upgradeSubscriptionFlow.setActiveScentIndex(activePlan)
    actions.models.upgradeSubscriptionFlow.setActiveMonthIndex(0)
    goToStep(constants.upgradeSubscriptionFlowSteps.selectedPlanSummary)
  }

  render() {
    const { activePlan } = this.state
    const { onClose } = this.props

    const planIndexes     = array.range(0, 2)
    const activePlanLink  = ValueLink.state(this, 'activePlan')

    return (
      <Fragment>
        <Title className={s.title} message={messages.title} />
        <FormattedMessage className={s.text} tag="div" {...messages.text} />
        <Media exceptMobile>
          <img className={s.image} src={getMore} alt="Upgrade subscription" />
        </Media>
        <RadioGroup className={s.planItems} valueLink={activePlanLink}>
          {
            planIndexes.map((index) => (
              <RadioButton key={index} className={s.planItem} brand value={index}>
                <FormattedMessage className={s.label} {...messages.planItem} values={{ value: index }} />
              </RadioButton>
            ))
          }
        </RadioGroup>
        <div className={s.actions}>
          <UpgradeButton
            className={s.button}
            disabled={!activePlan}
            fullWidth
            onClick={this.upgrade}
          />
          <Button
            className={s.button}
            title={messages.buttonClose}
            lightGray
            fullWidth
            onClick={onClose}
          />
        </div>
      </Fragment>
    )
  }
}


export default MonthlyPlanOptions
